'use client';
import { createStyles, getSize, xref, rem } from '@s7/styles';
import { getVariantColors } from './style.strategies.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var iconSizes = {
    xxs1: rem(24),
    xs1: rem(32),
    xs2: rem(36),
    sm1: rem(40),
    md1: rem(48),
    lg1: rem(56)
};
var useStyles = createStyles(function(theme, param, param1) {
    var transitionDuration = param.transitionDuration, radius = param.radius, color = param.color, textColor = param.textColor;
    var size = param1.size, variant = param1.variant;
    var text = theme.palette.text;
    var _theme_fn = theme.fn, focusRing = _theme_fn.focusRing, square = _theme_fn.square, transition = _theme_fn.transition, themeColor = _theme_fn.themeColor, primaryShade = _theme_fn.primaryShade;
    var _getVariantColors = getVariantColors(theme, color, variant), container = _getVariantColors.container, icon = _getVariantColors.icon, label = _getVariantColors.label;
    var iconSize = getSize({
        size: size,
        sizes: iconSizes
    });
    var iconXRef = xref("icon");
    var iconXClass = "." + iconXRef;
    var labelXRef = xref("label");
    var labelXClass = "." + labelXRef;
    var _obj, _obj1;
    return {
        root: _extends({
            boxSizing: "border-box",
            position: "relative",
            userSelect: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "fit-content"
        }, focusRing({
            color: container.focus,
            selector: "&:focus-visible " + iconXClass
        }), (_obj1 = {}, _obj1["&:hover " + iconXClass] = {
            background: container.hover,
            color: icon("hover")
        }, _obj1["&:active " + iconXClass] = {
            background: container.active,
            color: icon("active")
        }, _obj1["&:disabled,&[data-disabled=true]"] = (_obj = {
            pointerEvents: "none"
        }, _obj[iconXClass] = {
            background: "transparent",
            color: text.tertiary
        }, _obj[labelXClass] = {
            color: text.tertiary
        }, _obj), _obj1)),
        label: _extends({
            ref: labelXRef
        }, transition({
            props: "color",
            fn: "ease-in-out",
            duration: transitionDuration
        }), {
            lineHeight: "100%",
            color: textColor ? primaryShade(themeColor(textColor)) : label
        }),
        icon: _extends({
            ref: iconXRef
        }, transition({
            props: [
                "color",
                "background-color",
                "border-radius"
            ],
            fn: "ease-in-out",
            duration: transitionDuration
        }), {
            background: container.default,
            color: icon("default"),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, square({
            size: iconSize,
            radius: radius
        })),
        leftIcon: {},
        rightIcon: {}
    };
});

export { useStyles as default };
